/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteMcpServerHeader,
  RemoteMcpServerHeader$inboundSchema,
} from "./remotemcpserverheader.js";

/**
 * Result type for listing the headers of a remote MCP server
 */
export type ListServerHeadersResult = {
  headers: Array<RemoteMcpServerHeader>;
};

/** @internal */
export const ListServerHeadersResult$inboundSchema: z.ZodMiniType<
  ListServerHeadersResult,
  unknown
> = z.object({
  headers: z.array(RemoteMcpServerHeader$inboundSchema),
});

export function listServerHeadersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListServerHeadersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListServerHeadersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListServerHeadersResult' from JSON`,
  );
}
